import { ResumeData } from '../types/resume.types';

export const resumeData: ResumeData = {
  "personalInfo": {
    "name": "Thanh Nguyen",
    "title": "Senior QC Engineer",
    "email": "ng.tanthanh27@gmail.com",
    "phone": "",
    "location": "Vietnam",
    "linkedin": "https://linkedin.com/in/ngtanthanh",
    "github": ""
  },
  "about": "Experienced Senior Automation Test Engineer with 5+ years of expertise in building robust test automation frameworks and ensuring software quality. Specialized in API testing, Python automation, and CI/CD integration across multiple domains including networking, telecommunications, and enterprise solutions. Passionate about improving test coverage and reducing manual testing efforts through innovative automation solutions. Strong background in both manual and automated testing across web, API, and performance testing platforms.",
  "experience": [
    {
      "position": "Senior QC Engineer",
      "company": "MODEC",
      "duration": "Mar 2026 -- Present",
      "responsibilities": [
        "Sole QC engineer for an internal AI Chat application, owning the end-to-end quality lifecycle for feature requests coming from multiple internal teams and Product Owners across the company",
        "Authored Test Strategy and Test Plan documents, defining test scope, coverage targets, risk-based prioritization, and entry/exit criteria for each release",
        "Performed both manual and automation testing (functional, regression, integration) for new and existing AI Chat features",
        "Established testing practices and documentation from scratch as the first dedicated QC on the team, laying the foundation for scalable quality processes"
      ],
      "type": "current"
    },
    {
      "position": "Project Leader",
      "company": "Terralogic",
      "duration": "May 2025 -- Feb 2026",
      "responsibilities": [
        "Led API automation for Catalyst Center (Wireless, L2/L3, SDA Fabric), building and executing suites for standalone and integrated solutions",
        "Designed and implemented automated rate-limit testing with JMeter and Jenkins to validate API policies and optimize performance",
        "Collaborated with developers to triage issues and ensure timely delivery of high-quality releases",
        "Drove continuous improvements to testing processes and methodologies",
        "Consistently ranked as a top contributor for identifying and reporting high-impact defects; recognized for providing detailed root cause analysis that accelerated the debugging process for the development team"
      ]
    },
    {
      "position": "Senior QC Engineer",
      "company": "Terralogic",
      "duration": "Nov 2022 -- May 2023",
      "responsibilities": [
        "Automated external API tests for DNAC using Python and Postman",
        "Developed comprehensive test automation frameworks for networking solutions",
        "Performed manual and automated testing across multiple product lines"
      ]
    },
    {
      "position": "Software Engineer in Test",
      "company": "Cisco (On-site)",
      "duration": "Apr 2024 -- June 2024",
      "responsibilities": [
        "Selected to work on-site in San Jose, contributing to a software engineering project, building testbed topology"
      ]
    },
    {
      "position": "Test Automation Engineer",
      "company": "TMA Solutions",
      "duration": "Aug 2020 -- Sep 2022",
      "responsibilities": [],
      "projects": [
        {
          "title": "Project 1: Automation on J-100 devices (IP Phone) — Avaya",
          "description": [
            "Enhanced libraries and automated test cases using a telnet connection via PTI in Java"
          ]
        },
        {
          "title": "Project 2: Automation on Web Portal for Ready Now Solution — Avaya",
          "description": [
            "Automated web portal test cases using Selenium, Robot Framework, and Python."
          ]
        },
        {
          "title": "Project 3: Automation solution for CCaaS LE",
          "description": [
            "Built automation for installation and related tasks using Python, Postman, and Jenkins."
          ]
        }
      ]
    },
    {
      "position": "Intern Tester",
      "company": "IMT Solutions",
      "duration": "Jun 2020 -- Aug 2020",
      "responsibilities": [
        "Learned foundational testing methodologies and practices.",
        "Manual Test with harness testing platform to test Oracle libraries"
      ]
    },
    {
      "position": "Promotions Specialist",
      "company": "AG Trade & Investment Promotion Center",
      "duration": "Mar 2016 -- Feb 2020",
      "responsibilities": []
    },
    {
      "position": "Credit Management Specialist",
      "company": "DongA Bank - Head Office",
      "duration": "Oct 2014 -- Nov 2015",
      "responsibilities": []
    }
  ],
  "education": [
    {
      "degree": "Bachelor's degree",
      "institution": "University of Information Technology",
      "duration": "2021 -- 2023",
      "field": "Information Technology"
    },
    {
      "degree": "Bachelor's degree",
      "institution": "University of Economics and Law",
      "duration": "2010 -- 2014",
      "field": "Finance and Banking"
    }
  ],
  "skills": [
    {
      "category": "Programming Languages",
      "items": [
        "Python",
        "SQL",
        "JavaScript",
        "TypeScript"
      ]
    },
    {
      "category": "Test Automation Frameworks",
      "items": [
        "Robot Framework",
        "Selenium WebDriver",
        "Playwright"
      ]
    },
    {
      "category": "API Testing",
      "items": [
        "Postman",
        "Python Requests",
        "REST/SOAP protocols"
      ]
    },
    {
      "category": "Performance Testing",
      "items": [
        "JMeter",
        "Load Testing",
        "Rate-limit validation"
      ]
    },
    {
      "category": "CI/CD & DevOps",
      "items": [
        "Jenkins",
        "GitLab CI",
        "Docker",
        "Git"
      ]
    },
    {
      "category": "Analysis & Debugging",
      "items": [
        "Root Cause Analysis",
        "Log Analysis",
        "API Debugging"
      ]
    },
    {
      "category": "Testing Methodologies",
      "items": [
        "Agile",
        "SDLC",
        "STLC",
        "BDD"
      ]
    },
    {
      "category": "AI & Emerging Tech",
      "items": [
        "Prompting Engineering",
        "Applied AI",
        "MCP"
      ]
    },
    {
      "category": "Project Management",
      "items": [
        "JIRA",
        "Confluence",
        "Test Planning"
      ]
    }
  ],
  "certifications": [
    {
      "name": "Award: 3 Snap Awards (Quarterly)",
      "issuer": "Terralogic",
      "date": "",
      "credentialId": ""
    },
    {
      "name": "Award: Performance Outstanding Award",
      "issuer": "Cisco",
      "date": "",
      "credentialId": "",
      "url": "https://www.linkedin.com/in/ngtanthanh/overlay/1760409529349/single-media-viewer/?profileId=ACoAAC8-sPgBisB8dJY3JR9BZk7xUE14jEGQ6tE"
    },
    {
      "name": "Python for Everybody Specialization",
      "issuer": "",
      "date": "",
      "url": "https://www.coursera.org/account/accomplishments/specialization/certificate/QJWWDSEANFMY"
    },
    {
      "name": "Introduction to Machine Learning",
      "issuer": "",
      "date": "",
      "url": "https://www.linkedin.com/in/ngtanthanh/details/certifications/1754315537851/single-media-viewer?type=DOCUMENT&profileId=ACoAAC8-sPgBisB8dJY3JR9BZk7xUE14jEGQ6tE&lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_certifications_details%3BHIA%2BmDn4RMGdZc%2FU4lKcFQ%3D%3D"
    },
    {
      "name": "Google Project Management",
      "issuer": "",
      "date": "",
      "url": "https://coursera.org/verify/professional-cert/DYN6GPJW03S3"
    },
    {
      "name": "Google AI Essentials",
      "issuer": "",
      "date": "",
      "url": "https://www.coursera.org/account/accomplishments/records/FD73TXXYLE2Q"
    },
    {
      "name": "Black Belt Cisco Catalyst Center Deployment Stage 1",
      "issuer": "",
      "date": "",
      "url": "https://cf-ap1.mindtickle.com/1860013409316147822/public-content/1750924453271appoutputcertificateHVrAwXPLzg.pngZUbe.webp"
    },
    {
      "name": "Ethical Hacker",
      "issuer": "",
      "date": "",
      "url": "https://www.credly.com/badges/dfb38e59-46f1-4c20-af1b-2e24b41b29da/linked_in_profile"
    },
    {
      "name": "AWS Cloud Technical Essentials",
      "issuer": "",
      "date": "",
      "url": "https://www.coursera.org/account/accomplishments/verify/SJ4AZ8TDS62E"
    },
    {
      "name": "Microsoft Certified: Power BI Data Analyst Associate",
      "issuer": "",
      "date": "",
      "url": "https://learn.microsoft.com/api/credentials/share/en-us/NguyenTanThanh-CTR/BC344637C84F607A?sharingId=6EAB75B509C0329A"
    },
    {
      "name": "Microsoft Certified: Azure Administrator Associate",
      "issuer": "",
      "date": "",
      "url": "https://learn.microsoft.com/api/credentials/share/en-us/NguyenTanThanh-CTR/1CAF03999DEC0A0F?sharingId=6EAB75B509C0329A"
    },
    {
      "name": "Avaya OneCloud™ CCaaS Public Omnichannel Administrator",
      "issuer": "",
      "date": "",
      "url": "https://1drv.ms/b/s!AkoRSaVyXPNyd6LywyNk3g0UIfw?e=uRM8Z9"
    },
    {
      "name": "Building LLM Applications With Prompt Engineering",
      "issuer": "",
      "date": "",
      "url": "https://learn.nvidia.com/certificates?id=dijwBOJTRG-SaSQ4jy-kVw"
    },
    {
      "name": "Introduction to Transformer-Based Natural Language Processing",
      "issuer": "",
      "date": "",
      "url": "https://learn.nvidia.com/certificates?id=ydx0TLsHTlCNQTAb4OZjcg"
    }
  ]
};
